import { useState } from "react";
import { FaChevronRight, FaSignOutAlt, FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./MenuTab.css";

const MenuTab = ({
  top,
  image,
  bottom,
  title,
  hoverWidth,
  link,
  isMenu = false,
  setLoginOpen,
  isLogin = false,
  logout,
  onClick,
  badge = null,
}) => {
  const user = useSelector((state) => state.user.user);
  const [showMenu, setShowMenu] = useState(false);
  // const [isFocus, setIsFocus] = useState(false);
  const isFocus = false;
  const [accHover, setAccHover] = useState(false);
  const [logHover, setLogHover] = useState(false);

  const onDivHover = () => {
    setShowMenu(true);
  };
  const onDiv = () => {
    setShowMenu(false);
  };
  const accEnter = () => {
    setAccHover(!accHover);
  };
  const logEnter = () => {
    setLogHover(!logHover);
  };

  const divStyle = {
    opacity: showMenu ? 1 : 0,
    pointerEvents: showMenu ? "all" : "none",
    position: "fixed",
    transition: "0.5s all",
    transform: showMenu ? "translateY(0)" : "translateY(-100%)",
    width: 200,
    background: "white",
    borderRadius: 10,
    top: top,
    bottom: bottom,
    right: hoverWidth - 5,
  };
  const menuStyle1 = {
    transition: "0.5s all",
    transform: showMenu ? "translateX(0)" : "translateX(100%)",
  };
  const menuStyle2 = {
    transition: "0.5s all",
    transform: showMenu ? "translateX(0)" : "translateX(-100%)",
  };
  const menuStyle3 = {
    transition: "0.5s all",
    transform: showMenu ? "translateY(0)" : "translateY(600%)",
  };

  return (
    <div
      className="d-none d-md-block"
      style={{ position: "relative" }}
      onClick={onClick}
    >
      {!isLogin ? (
        isMenu ? (
          <div
            onMouseLeave={onDiv}
            onMouseEnter={onDivHover}
            style={{
              width: showMenu ? hoverWidth : 50,
              position: "fixed",
              top: top,
              right: 10,
              zIndex: 200,
              overflow: "hidden",
            }}
            className={`tab ${
              isFocus ? "focus" : ""
            } text-decoration-none text-dark`}
          >
            <img
              alt="asset"
              className="tab-image my-auto"
              src={`/assets/${image}`}
            />
            &nbsp;<span className="tab-name my-auto fw-bold">{title}</span>
            {isMenu && (
              <div className={`tab-menu shadow px-2 `} style={divStyle}>
                {user && (
                  <Link
                    to={link ?? "/"}
                    className={`d-flex py-2 text-dark text-decoration-none `}
                    style={menuStyle1}
                  >
                    <img
                      src={
                        user.avatar ??
                        "https://ui-avatars.com/api/?background=ec008c&color=ffffff&name=" +
                          user.name
                      }
                      width="30"
                      height="30"
                      className={` d-flex my-auto ${showMenu ? " bounce" : ""}`}
                      alt={user.name}
                      style={{ borderRadius: "50%", objectFit: "cover" }}
                    />
                    <p className="my-auto small ms-1">{user.name}</p>
                  </Link>
                )}
                <div
                  onMouseEnter={accEnter}
                  onMouseLeave={accEnter}
                  className="py-2 border-bottom "
                  style={menuStyle2}
                >
                  <Link
                    to={link ?? "/"}
                    className="text-decoration-none text-black d-flex"
                  >
                    <FaUser
                      style={{
                        transition: "0.5s all",
                        opacity: accHover ? 1 : 0,
                        transform: accHover
                          ? "translateX(100%)"
                          : "translateX(0)",
                      }}
                      className="my-auto"
                    />
                    <p
                      className="my-auto"
                      style={{
                        marginLeft: accHover ? "10px" : "0px",
                        transition: "0.5s all",
                        transform: accHover
                          ? "translateX(10%)"
                          : "translateX(0)",
                      }}
                    >
                      My Account
                    </p>
                  </Link>
                </div>
                <div
                  onMouseEnter={logEnter}
                  onMouseLeave={logEnter}
                  onClick={(e) => {
                    e.stopPropagation();
                    logout();
                  }}
                  className="py-2 d-flex"
                  style={menuStyle3}
                >
                  <FaSignOutAlt
                    style={{
                      transition: "0.5s all",
                      opacity: logHover ? 1 : 0,
                      transform: logHover
                        ? "translateX(100%)"
                        : "translateX(0)",
                    }}
                    className="my-auto"
                  />
                  <p
                    className="my-auto"
                    style={{
                      marginLeft: logHover ? "10px" : "0px",
                      transition: "0.5s all",
                      transform: logHover ? "translateX(10%)" : "translateX(0)",
                    }}
                  >
                    Logout
                  </p>
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            {link ? (
              <Link
                to={link ?? "/"}
                onMouseLeave={onDiv}
                onMouseEnter={onDivHover}
                style={{
                  width: showMenu ? hoverWidth : 50,
                  position: "fixed",
                  top: top,
                  bottom: bottom,
                  right: 10,
                  zIndex: 200,
                  overflow: "hidden",
                }}
                className="tab text-decoration-none text-dark "
              >
                <img
                  alt="asset"
                  className="tab-image my-auto"
                  src={`/assets/${image}`}
                />
                &nbsp;<span className="tab-name my-auto fw-bold">{title}</span>
              </Link>
            ) : (
              <div
                onMouseLeave={onDiv}
                onMouseEnter={onDivHover}
                style={{
                  width: showMenu ? hoverWidth : 50,
                  position: "fixed",
                  top: top,
                  bottom: bottom,
                  right: 10,
                  zIndex: 200,
                  overflow: "hidden",
                }}
                className="tab text-decoration-none text-dark "
              >
                <img
                  alt="asset"
                  className="tab-image my-auto"
                  src={`/assets/${image}`}
                />
                &nbsp;<span className="tab-name my-auto fw-bold">{title}</span>
              </div>
            )}
            {badge ? (
              <div
                className="bg-danger d-flex justify-content-center align-items-center text-white p-2"
                style={{
                  position: "fixed",
                  top: top - 10,
                  bottom: bottom,
                  right: 0,
                  zIndex: 201,
                  height: 26,
                  width: 26,
                  borderRadius: 13,
                }}
              >
                {badge}
              </div>
            ):
            (
              null
            )
            }
          </>
        )
      ) : (
        <div
          onClick={() => {
            setLoginOpen(true);
          }}
          onMouseLeave={onDiv}
          onMouseEnter={onDivHover}
          style={{
            width: showMenu ? hoverWidth : 50,
            position: "fixed",
            top: top,
            bottom: bottom,
            right: 10,
            zIndex: 200,
            overflow: "hidden",
          }}
          className="tab text-decoration-none text-dark "
        >
          <img
            alt="asset"
            className="tab-image my-auto"
            src={`/assets/${image}`}
          />
          &nbsp;<span className="tab-name my-auto fw-bold">{title}</span>
          {isMenu && (
            <div className={`tab-menu  shadow px-2 `} style={divStyle}>
              <div
                onClick={() => {
                  setLoginOpen(true);
                }}
                onMouseEnter={accEnter}
                onMouseLeave={accEnter}
                className="py-2 border-bottom d-flex"
                style={menuStyle2}
              >
                <FaChevronRight
                  style={{
                    transition: "0.5s all",
                    opacity: accHover ? 1 : 0,
                    transform: accHover ? "translateX(100%)" : "translateX(0)",
                  }}
                  className="my-auto"
                />
                <p
                  className="my-auto"
                  style={{
                    marginLeft: accHover ? "10px" : "0px",
                    transition: "0.5s all",
                    transform: accHover ? "translateX(10%)" : "translateX(0)",
                  }}
                >
                  Login
                </p>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setLoginOpen(true, "2");
                }}
                onMouseEnter={logEnter}
                onMouseLeave={logEnter}
                className="py-2 d-flex"
                style={menuStyle3}
              >
                <FaChevronRight
                  style={{
                    transition: "0.5s all",
                    opacity: logHover ? 1 : 0,
                    transform: logHover ? "translateX(100%)" : "translateX(0)",
                  }}
                  className="my-auto"
                />
                <p
                  className="my-auto"
                  style={{
                    marginLeft: logHover ? "10px" : "0px",
                    transition: "0.5s all",
                    transform: logHover ? "translateX(10%)" : "translateX(0)",
                  }}
                >
                  Sign Up
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MenuTab;
